import { STATUS_ERROR, STATUS_INFO, STATUS_SUCCESS } from '@openclassrooms/ui-web/notifications';

import browser from '@openclassrooms/utils/browser';

import popMessage from './popMessage';

const alertTypeToStatus = {
  'alert-info': STATUS_INFO,
  'alert-success': STATUS_SUCCESS,
  'alert-error': STATUS_ERROR,
};

function index() {
  const messages = [...browser.document.querySelectorAll('[data-component="FlashMessage"]')];

  messages.forEach((message) => {
    const status = alertTypeToStatus[message.getAttribute('data-type')] || 'default';

    const content = message.innerHTML;
    message.parentNode.removeChild(message);

    popMessage(content, status);
  });
}

export default index;
